/**
 * Created by jv on 2019-08-21 (11:47).
 */
const businessModelImages = require.context("Images/business-model", false, /\.(svg|png|j(e)?pg)$/);

let animationDuration = 2000;

let infoSettings = {
  radius: 19,
  innerStrokeColor: "#000000",
  innerStrokeRadius: 29,
  innerStrokeWidth: 4,

  text: {
      fontFamily: "SpaceGrotesk", // %TODO: wss ander font ???
      fontSize: 24,
      alignment: "center",
      color: "#000000"
  },

  markedColor: "#57B67D"
}

let testLayout = {
  background: businessModelImages("./curved_background.svg"),
  backgroundColor: "#f4f7f9",

  size: {
    width: 1168,
    height: 730
  },

  infoSettings,

  animationDuration
};

export default testLayout;



// WEBPACK FOOTER //
// ./app/js/components/business-model/layouts/default.js